import { Vue, Component, Ref } from 'vue-property-decorator'
import StatisticalAnalysisHeader from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.vue'
import StatisticalAnalysisSidebar from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.vue'
import StatisticalAnalysisSidebarCmp from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar'
import StatisticalAnalysisViewDetail from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail/statistical-analysis-view-detail.vue'
import {
    StatisticalAnalysisActivityDossierState,
    initialStatisticalAnalysisActivityDossierState,
    StatisticalAnalysisActivityDossierModelSearchInfo,
    navigationItems
} from '@/modules/statistical-analysis-module/views/service-activity-dossier/service-activity-dossier.model'
import { activityStatisticsDossierService } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.service'
import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { StatisticalAnalysisActivityTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisActivityStatisticsDossierCaseStates } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.dto'
import StatisticalAnalysisSkeletonActivityDossierBase from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-activiy-dossier/statistical-analysis-skeleton-activity-dossier-base/statistical-analysis-skeleton-activity-dossier-base.vue'
import { isNil } from 'lodash'

@Component({
    components: {
        StatisticalAnalysisSidebar,
        StatisticalAnalysisHeader,
        StatisticalAnalysisViewDetail,
        StatisticalAnalysisSkeletonActivityDossierBase
    }
})
export default class StatisticalAnalysisDossier extends Vue {
    @Ref() readonly sidebar!: StatisticalAnalysisSidebarCmp

    state: StatisticalAnalysisActivityDossierState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisActivityDossierState()
    }

    get isInitDossier(): boolean {
        return !isNil(this.state.promiseNavigationItems)
    }

    async onSearch(search: StatisticalAnalysisActivityDossierModelSearchInfo): Promise<void> {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                startDate: search.startDate,
                endDate: search.endDate,
                states: search.states,
                typeSearch: search.typeSearch,
                laboratories: search.laboratories
            },
            headerData: {
                ...this.state.headerData,
                header: {
                    ...this.state.headerData.header,
                    startDate: search.startDate as Date,
                    endDate: search.endDate as Date
                },
                navigationItems: []
            }
        }
        this.state.promiseNavigationItems = this._getGeneralView()
    }

    private async _getGeneralView(): Promise<void> {
        const [error, response] = await this.$_toCall(activityStatisticsDossierService.getGeneralView(this.state.externalInfo), false)
        if (error) {
            this.state.headerData.navigationItems = [...navigationItems]
        } else {
            this.state.headerData.navigationItems = navigationItems.map((item: StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisActivityTypes>) => {
                if (item.key === StatisticalAnalysisActivityTypes.TOTAL) {
                    item.value = (response as StatisticalAnalysisActivityStatisticsDossierCaseStates).total
                } else if (item.key === StatisticalAnalysisActivityTypes.UCL) {
                    item.value = (response as StatisticalAnalysisActivityStatisticsDossierCaseStates).totalUCL
                } else {
                    item.value = (response as StatisticalAnalysisActivityStatisticsDossierCaseStates).totalURV
                }
                return item
            })
        }
    }
}
